import { useErrorInline } from '@/context/InlineErrorContext/InlineErrorContext';
import { ReceivedInvoiceDetail } from '@/context/services/invoice/type';
import { ViewContextProvider } from '@/features/invoices/components/Details/Components/Context/ViewEdit';
import { InvoiceReports } from '@/features/invoices/components/Details/Components/InvoiceReports';
import { OCRResult } from '@/features/invoices/components/Details/Components/OCRResult/OCRResult';
import { useSplitViewDragging } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo } from 'react';
import { EDocMetadata } from '../EDocMetadata';
import { ReceivedInvoice } from '../ReceivedInvoice';
import { Notification } from './InlineNotification';
import styles from './Right.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  data: ReceivedInvoiceDetail;
};

export const Right: FC<Props> = memo(({ data }) => {
  const { ErrorContextHolder } = useErrorInline();

  const isSplitViewDragging = useSplitViewDragging();

  return (
    <ViewContextProvider>
      <div
        className={cx(styles['container'])}
        // eslint-disable-next-line @moneyforward/account-payable/literals-in-props
        style={{ userSelect: isSplitViewDragging ? 'none' : undefined }}
        data-testid='container'
      >
        <div className={cx(styles['contentContainer'])}>
          <div className={cx(styles['content'])}>
            <div className={cx(styles['errorContainer'])}>
              {ErrorContextHolder}
            </div>
            <Notification />
            <InvoiceReports data={data.invoice_report} />
            <ReceivedInvoice data={data} />
            <OCRResult data={data} />
            <EDocMetadata
              receiptType={data.receipt_type ?? undefined}
              eDocMetaDatum={data.mf_file?.e_doc_meta_datum}
            />
          </div>
        </div>
      </div>
    </ViewContextProvider>
  );
});
Right.displayName = 'Right';
